// Background soundtrack — an HTMLAudioElement that loops quietly the
// whole time the game is running. Because browsers require a user
// gesture before audio can play, `startSoundtrack()` is called from the
// title-screen dismiss handler (the first key/click counts).

const DEFAULT_VOLUME = 0.18;
const FADE_IN_MS     = 1200;

let audio = null;

export function initSoundtrack(src = '/soundtrack.mp3') {
  audio = new Audio(src);
  audio.loop    = true;
  audio.volume  = 0;
  audio.preload = 'auto';

  audio.addEventListener('error', () => {
    console.warn(
      '[soundtrack] load error — code',
      audio.error?.code, audio.error?.message,
      'src:', audio.currentSrc,
    );
  });
  audio.addEventListener('canplaythrough', () => {
    console.log('[soundtrack] ready');
  });

  // Expose for easy DevTools poking.
  if (typeof window !== 'undefined') window.__soundtrack = audio;
}

export function startSoundtrack() {
  if (!audio) return;
  if (!audio.paused) return;

  const p = audio.play();
  if (p && typeof p.then === 'function') {
    p.then(() => {
      console.log('[soundtrack] playing');
      const start = performance.now();
      const fade = (now) => {
        const t = Math.max(0, Math.min(1, (now - start) / FADE_IN_MS));
        if (audio) audio.volume = t * DEFAULT_VOLUME;
        if (t < 1) requestAnimationFrame(fade);
      };
      requestAnimationFrame(fade);
    }).catch((err) => {
      console.warn('[soundtrack] play() rejected:', err);
    });
  }
}

export function setSoundtrackVolume(v) {
  if (audio) audio.volume = Math.max(0, Math.min(1, v));
}

export function stopSoundtrack() {
  if (audio) { audio.pause(); audio.currentTime = 0; }
}
